import { FetchableResourceStatus } from '~/_shared/types/fetchableResource/fetchableResource';
import { getLoadingStateFetchableResource } from '~/_shared/types/fetchableResource/fetchableResource.helpers';
import { copy } from '~/_shared/utils/collections/collections';
import { notNull } from '~/_shared/utils/typeGuards';
import type { PlacesAction } from './places.action';
import {
  placeInListHoverEnd,
  placeInListHoverStart,
  placesSearchesGetResultsSuccess,
  placesSearchesRequestNextPage, placesSearchesSetLoading,
  placesSearchHoverStart, placesSearchHoverStop,
  placesToolCollapseSearch,
  placesToolExpandSearch,
  placesToolSetStartingLocation,
} from './places.actionCreators';
import type { PlacesState } from './places.state';

const initialState: PlacesState = {
  hoveredSearchId: null,
  hoveredPlaceInList: null,
  expandedSearchIds: new Set(),
  searchResults: new Map(),
  startingLocation: null,
};

export const placesReducer = (state = initialState, action: PlacesAction): PlacesState => {

  if (placesSearchesSetLoading.match(action)) {
    return {
      ...state,
      searchResults: new Map(
        copy.andAdd(state.searchResults, Array.from(action.payload.searchIds).map((searchId) => {
          const stateSearchResultsForSearchId = state.searchResults.get(searchId);
          if (stateSearchResultsForSearchId) {
            return [searchId, { ...stateSearchResultsForSearchId, status: FetchableResourceStatus.Loading }];
          }
          return [searchId, getLoadingStateFetchableResource()];
        }))
      ),
    };
  }

  if (placesSearchesRequestNextPage.match(action)) {
    return {
      ...state,
      searchResults: copy.andAdd(state.searchResults, new Map(
        Array.from(action.payload.searchIds).map((searchId) => {
          const stateSearchResultsForSearchId = state.searchResults.get(searchId);
          if (stateSearchResultsForSearchId) {
            return [searchId, { ...stateSearchResultsForSearchId, status: FetchableResourceStatus.NextPageRequested }] as const;
          }
          return null;
        }).filter(notNull))
      ),
    };
  }

  if (placesSearchesGetResultsSuccess.match(action)) {
    return {
      ...state,
      searchResults: copy.andAdd(state.searchResults, action.payload.results),
    };
  }

  if (placesToolExpandSearch.match(action)) {
    return {
      ...state,
      expandedSearchIds: copy.andAdd(state.expandedSearchIds, [action.payload.id]),
    };
  }

  if (placesToolCollapseSearch.match(action)) {
    return {
      ...state,
      expandedSearchIds: copy.andRemove(state.expandedSearchIds, [action.payload.id]),
    };
  }

  if (placesToolSetStartingLocation.match(action)) {
    return {
      ...state,
      startingLocation: action.payload.location,
    };
  }

  if (placesSearchHoverStart.match(action)) {
    return {
      ...state,
      hoveredSearchId: action.payload.searchId,
    };
  }

  if (placesSearchHoverStop.match(action)) {
    return {
      ...state,
      hoveredSearchId: null,
    };
  }

  if (placeInListHoverStart.match(action)) {
    return {
      ...state,
      hoveredPlaceInList: {
        id: action.payload.placeId,
        placeSearchId: action.payload.placeSearchId,
      },
    };
  }

  if (placeInListHoverEnd.match(action)) {
    return {
      ...state,
      hoveredPlaceInList: null,
    };
  }

  return state;
};
